import React, { Component } from 'react';

export default class StaticPage extends Component {
  render() {
    return <div> Welcome to Static Page 3 </div>;
  }
}
